<div class="tooltip-container">
  <mat-icon class="info-icon hand-cursor"
            [matTooltip]="matTooltip"
            [matTooltipPosition]="matTooltipPosition"
            [matTooltipShowDelay]="matTooltipShowDelay"
            [matTooltipHideDelay]="matTooltipHideDelay"
            [matTooltipClass]="matTooltipClass"
            [matTooltipDisabled]="matTooltipDisabled">
    {{matIconName}}
  </mat-icon>
</div>